module.exports = __webpack_public_path__ + "static/media/teltonika-fmc130-2.1c8b4340.png";